import { render, staticRenderFns } from "./TemplateChartActs.vue?vue&type=template&id=3cd6ed31&scoped=true&"
import script from "./TemplateChartActs.vue?vue&type=script&lang=js&"
export * from "./TemplateChartActs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd6ed31",
  null
  
)

export default component.exports